import React, { useEffect, useState } from 'react';
import {
  Button,
  TextField,
  type UserRole,
} from '../../../../../../../components';
import { type PanelRemarks as PanelRemarksType } from '../../../../../graphql';
import { PANEL_FORM_DIALOG_TEXT } from '../../../../../lang';

type PanelRemarksProps = {
  remarks: PanelRemarksType[];
  applicationId: string;
  disabled: boolean;
  triggerNum: number;
  currentRoleModule: UserRole | undefined;
  remarksToRole: UserRole.PANEL | UserRole.DO_RPG_S;
  handleSavePanelRemarks: (
    applicationId: string,
    remarks: string,
    toRole: UserRole.PANEL | UserRole.DO_RPG_S,
  ) => Promise<void>;
};

const PanelRemarks: React.FunctionComponent<PanelRemarksProps> = (
  props: PanelRemarksProps,
) => {
  const {
    applicationId,
    remarks,
    disabled,
    triggerNum,
    currentRoleModule,
    remarksToRole,
    handleSavePanelRemarks,
  } = props;

  const latestRemark =
    remarks.length === 0 ? '' : (remarks[remarks.length - 1].remark ?? '');
  // local hook
  const [remarkInput, setRemarkInput] = useState<string>(latestRemark);
  // local re-render
  useEffect(() => {
    setRemarkInput(latestRemark);
  }, [triggerNum]);
  return (
    <div key={triggerNum}>
      {!disabled ? (
        <div className="flex flex-col justify-center gap-2 p-1 border border-[1px] border-[#951D1D] min-w-[140px]">
          <TextField
            value={remarkInput}
            multiline
            rows={5}
            onChange={e => {
              setRemarkInput(e.target.value);
            }}
            sx={{
              bgcolor: 'white',
              fontSize: '12',
            }}
          />

          <div>
            <Button
              size="small"
              variant="contained"
              className="!normal-case"
              disabled={currentRoleModule == null || !remarkInput}
              onClick={async () => {
                await handleSavePanelRemarks(
                  applicationId,
                  remarkInput,
                  remarksToRole,
                );
              }}
            >
              {PANEL_FORM_DIALOG_TEXT.SAVE}
            </Button>
          </div>
        </div>
      ) : (
        <>{latestRemark}</>
      )}
    </div>
  );
};
const MemoizedPanelRemarks = React.memo(PanelRemarks);
export { MemoizedPanelRemarks };
